// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomNumberInput_wrapper__V4rnI","label":"CustomNumberInput_label__hiVF6","errorMessage":"CustomNumberInput_errorMessage__3lofj"};